import React from 'react';

import { Bridge } from './sdk';
import { useStrictContext } from '../../lib/useStrictContext';

const GameBridgeContext = React.createContext<Bridge | null>(null);

export const GameBridgeProvider: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <GameBridgeContext.Provider value={window.bridge}>
            {props.children}
        </GameBridgeContext.Provider>
    );
};

export const useGameBridge = () => useStrictContext(GameBridgeContext);
